var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 11,
    r: 9.75,
    stroke: "white",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1133 6.55547C9.92539 6.6418 9.75781 6.81953 9.68672 7.00742C9.65117 7.09883 9.63086 7.7082 9.63086 8.64258V10.1355L8.06172 10.1508C6.56367 10.166 6.48242 10.1711 6.35039 10.2727C6.08125 10.4707 6 10.6332 6 10.9531C6 11.273 6.08125 11.4355 6.35039 11.6336C6.48242 11.7352 6.56367 11.7402 8.05664 11.7555L9.62578 11.7707L9.64102 13.3398C9.65625 14.8328 9.66133 14.9141 9.76289 15.0461C9.96094 15.3152 10.1234 15.3965 10.4434 15.3965C10.7633 15.3965 10.9258 15.3152 11.1238 15.0461C11.2254 14.9141 11.2305 14.8328 11.2457 13.3398L11.2609 11.7707L12.8301 11.7555C14.323 11.7402 14.4043 11.7352 14.5363 11.6336C14.8055 11.4355 14.8867 11.273 14.8867 10.9531C14.8867 10.6332 14.8055 10.4707 14.5363 10.2727C14.4043 10.1711 14.323 10.166 12.8301 10.1508L11.2609 10.1355L11.2457 8.56641C11.2305 7.07344 11.2254 6.99219 11.1238 6.86016C11.068 6.78399 10.9613 6.67227 10.8902 6.62148C10.7176 6.49453 10.3164 6.45898 10.1133 6.55547Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreate);
export default __webpack_public_path__ + "static/media/create.b7415414f9d1570ddd0c91ab54e7d61b.svg";
export { ForwardRef as ReactComponent };